/**
 * Dependencies
 */
import http from '../../../../../services/HttpService'

/**
 * Get the exit assumption data
 *
 * @param {Function} commit
 * @return Void
 */
const getData = ({ commit, rootState }) => {
    commit('SET_LOADING')
    http.get(`projects/${rootState.route.params.projectId}/net-proceeds/`)
        .then(res => {
            commit('GET_DATA_SUCCESS', res.data)
            commit('RESET_LOADING')
        })
        .catch(err => {
            commit('GET_DATA_FAILURE', err.response.data)
            commit('RESET_LOADING')
        })
}

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Save the model
 *
 * @param {Function} commit
 */
const saveModel = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        http.patch(payload.url, payload.value)
            .then(res => {
                commit('GET_DATA_SUCCESS', res.data)
                resolve()
            })
            .catch(err => {
                reject(err)
            })
    })
}

export default {
    getData,
    saveModel,
    resetState
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/net-proceeds/actions.js